module.exports = __webpack_public_path__ + "img/kayak-icon.98e9b0b6.svg";